export function formatCloudinary(imageSrc) {
    if (typeof imageSrc !== 'string' || !imageSrc.length) {
        return ''
    }
    if (imageSrc.includes('res.cloudinary.com')) {
        return `${process.env.NEXT_PUBLIC_PUBLIC_APP_URL}/api/img/htkavmx5a/image/upload/f_auto,q_auto,c_limit,h_2048,w_2048/${imageSrc.split('/').pop()}`
    }
    return imageSrc
}
